<template>
  <div class="rank-page" :class="{page:supervisorMode}">
    <van-nav-bar :title="supervisorMode ? '团队排行榜' : '绩效排行榜'" left-arrow @click-left="$router.back()"/>
    <van-tabs v-if="!supervisorMode" v-model="scopeIndex" @change="load">
      <van-tab title="公司榜"/>
      <van-tab title="部门榜"/>
    </van-tabs>
    <section class="month">
      <button @click="change(-1)">
        <van-icon name="arrow-left"/>
      </button>
      <b>{{ month.replace('-', ' 年 ') }} 月</b>
      <button @click="change(1)">
        <van-icon name="arrow"/>
      </button>
    </section>
    <van-skeleton v-if="loading" title :row="8"/>
    <main v-else>
      <article v-for="item in rows" :key="item.employeeId" :class="{mine:item.currentEmployee}"><strong :class="'rank r' + item.rank">{{
          item.rank
        }}</strong>
        <div class="avatar">{{ item.employeeName.slice(-1) }}</div>
        <div class="name"><b>{{ item.employeeName }}<i v-if="item.currentEmployee">我</i></b><span>{{ item.departmentName }} · {{
            item.positionName
          }}</span></div>
        <div class="score"><b>{{ Number(item.score).toFixed(1) }}</b><span>综合分</span></div>
      </article>
      <van-empty v-if="!rows.length" description="本月暂无绩效数据"/>
    </main>
  </div>
</template>

<script>
/**
 * 绩效排行榜：公司榜 / 部门榜切换；主管模式（supervisor=1）保留本人条目参与排名。
 */
import coreapi from '@/utils/coreapi';

export default {
  data() {
    const d = new Date();
    return {
      scopeIndex: this.$route.query.supervisor === '1' ? 1 : 0,
      month: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
      rows: [],
      loading: false
    };
  },
  computed: {
    supervisorMode() {
      return this.$route.query.supervisor === '1';
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const rows = await coreapi.leaderboard(this.month, this.scopeIndex ? 'DEPARTMENT' : 'COMPANY');
        this.rows = rows;
      } catch (e) {
        this.$toast.fail(e.message);
      } finally {
        this.loading = false;
      }
    },
    change(offset) {
      const parts = this.month.split('-');
      const d = new Date(+parts[0], +parts[1] - 1 + offset, 1);
      this.month = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      this.load();
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/assets/base.less";
@import "./supervisor/supervisor.less";

.rank-page {
  min-height: 100vh;
  padding-bottom: 1.65rem;
  background: #f6f7fb
}

.rank-page.page {
  min-height: calc(100vh - 1rem);
  padding-bottom: 0
}

.month {
  height: 1.1rem;
  padding: 0 .3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff
}

.month button {
  width: .8rem;
  height: .8rem;
  color: #777;
  font-size: .36rem
}

.month b {
  font-size: .34rem
}

main {
  padding: .25rem .28rem
}

article {
  min-height: 1.35rem;
  margin-bottom: .16rem;
  padding: .2rem .26rem;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: .16rem;
  box-shadow: 0 .05rem .2rem rgba(211, 47, 47, .07)
}

article.mine {
  border: 1PX solid @color;
  background: #fff5f5
}

.rank {
  flex: 0 0 .6rem;
  width: .6rem;
  color: #9a9ca8;
  text-align: center;
  font-size: .35rem;
  line-height: 1
}

.r1 {
  color: #e0a629
}

.r2 {
  color: #8992a5
}

.r3 {
  color: #bd7a50
}

.avatar {
  flex: 0 0 .76rem;
  width: .76rem;
  height: .76rem;
  line-height: .76rem;
  margin: 0 .2rem;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  background: @color;
  font-size: .28rem;
  white-space: nowrap;
  overflow: hidden
}

.name {
  min-width: 0;
  flex: 1
}

.name b, .name span {
  display: block
}

.name b {
  font-size: .32rem
}

.name i {
  margin-left: .1rem;
  padding: .02rem .1rem;
  color: #fff;
  border-radius: .12rem;
  background: @color;
  font-size: .2rem;
  font-style: normal
}

.name span {
  margin-top: .06rem;
  overflow: hidden;
  color: #9294a5;
  font-size: .25rem;
  text-overflow: ellipsis;
  white-space: nowrap
}

.score {
  text-align: right
}

.score b, .score span {
  display: block
}

.score b {
  color: @color;
  font-size: .4rem
}

.score span {
  color: #aaa;
  font-size: .22rem
}
</style>



// WEBPACK FOOTER //
// src/views/efficiency/Leaderboard.vue